var socialLinks = {

	// ----- VARS ----- //
	elms: {
		body: $( 'body' ),
		links: $( 'a[data-social-platform]' )
	},
	facebookAppId: undefined,
	siteTitle: undefined,


	// ----- CONSTANTS ----- //
	PLATFORM_FACEBOOK: 'facebook',
	PLATFORM_MESSENGER: 'messenger',
	PLATFORM_PINTEREST: 'pinterest',
	PLATFORM_TWITTER: 'twitter',
	PLATFORM_WHATSAPP: 'whatsapp',

	TEXT_DIVIDER: ' - ',


	// ----- FUNCTIONS ----- //
	init: function() {
		socialLinks.facebookAppId = socialLinks.elms.body.data( 'facebook-app-id' );
		socialLinks.siteTitle = socialLinks.elms.body.data( 'site-title' );

		//console.log( 'socialLinks: init' );

		//console.log( 'facebookAppId:', socialLinks.facebookAppId);
		//console.log( 'siteTitle:', socialLinks.siteTitle );

		// Create Social Links
		socialLinks.create();

		// Add Event Listeners
		socialLinks.elms.links.on( 'click', socialLinks.onClick );

	},

	add: function( el ) {
		////console.log( 'socialLinks: add' );

		var links = el.find( 'a[data-social-platform]' );
		links.on( 'click', socialLinks.onClick );

		socialLinks.create( links );
		socialLinks.elms.links = socialLinks.elms.links.add( links );

	},

	create: function( links, selector ) {
		//console.log( 'socialLinks: create' );

		var platform;

		links = links || socialLinks.elms.links;

		links.each( function( index, link ) {

			platform = link.getAttribute( 'data-social-platform' ).toLowerCase();

			// link = the <a> tag
			// selector = the element which contain the data attributes.
			// need to pass it for links within the product modal, which is located now OUTSIDE the selector

			switch ( platform ) {

				case socialLinks.PLATFORM_FACEBOOK:
					socialLinks.createFacebook( link, selector );
					break;

				case socialLinks.PLATFORM_MESSENGER:
					socialLinks.createMessenger( link, selector );
					break;

				case socialLinks.PLATFORM_PINTEREST:
					socialLinks.createPinterest( link, selector );
					break;

				case socialLinks.PLATFORM_TWITTER:
					socialLinks.createTwitter( link, selector );
					break;

				case socialLinks.PLATFORM_WHATSAPP:
					socialLinks.createWhatsApp( link, selector );
					break;

			}

		} );

	},

	createFacebook: function( link, selector ) {
		////console.log( 'socialLinks: createFacebook' );

		var elm = selector || link;

		var title = socialLinks.getTitle( elm );
		var url = socialLinks.getUrl( elm );
		var display = ( $.browser.desktop ) ? 'popup' : 'touch';

		link.setAttribute( 'href',
			'https://www.facebook.com/dialog/feed' +
			'?app_id=' + socialLinks.facebookAppId +
			'&display=' + display +
			'&caption=' + title +
			'&link=' + url
		);
		link.setAttribute( 'target', '_blank' );

	},

	createMessenger: function( link, selector ) {
		////console.log( 'socialLinks: createMessenger' );

		var elm = selector || link;

		var title = socialLinks.getTitle( elm );
		var url = socialLinks.getUrl( elm );

		link.setAttribute( 'href',
			'fb-messenger://share' +
			'?app_id=' + socialLinks.facebookAppId +
			'&caption=' + title +
			'&link=' + url
		);

	},

	createPinterest: function( link, selector ) {
		//console.log( 'socialLinks: createPinterest' );

		var elm = selector || link;

		var title = socialLinks.getTitle( elm );
		var image = socialLinks.getImage( elm );
		var url = socialLinks.getUrl( elm );

		//console.log('image url for sharing: ', image);

		link.setAttribute( 'href',
			'https://pinterest.com/pin/create/button/' +
			'?description=' +  title +
			'&media=' + image +
			'&url=' + url
		);
		link.setAttribute( 'target', '_blank' );
	},

	createTwitter: function( link, selector ) {
		//console.log( 'socialLinks: createTwitter' );
		// //console.log( '>>> socialLinks: selector', selector );
		// //console.log( '>>> socialLinks: link', link );

		var elm = selector || link;

		var title = socialLinks.getTitle( elm );
		var url = socialLinks.getUrl( elm );

		link.setAttribute( 'href',
			'https://twitter.com/intent/tweet' +
			'?text=' + title +
			'&url=' + url
		);
		link.setAttribute( 'target', '_blank' );

	},

	createWhatsApp: function( link, selector ) {
		////console.log( 'socialLinks: createWhatsApp' );

		var elm = selector || link;

		var title = socialLinks.getTitle( elm );
		var url = socialLinks.getUrl( elm );

		link.setAttribute( 'href',
			'whatsapp://send' +
			'?text=' + title +
			'%20' + url
		);
		link.setAttribute( 'data-action', 'share/whatsapp/share' );

	},

	getImage: function( elm ) {
		//console.log('getImage, elm: ', elm);

		var $elm = $( elm );
		var image = $elm.closest( '*[data-share-image]' ).attr( 'data-share-image' );

		if (!image){
			//console.log('using data-image-src');
			image = $elm.closest( '*[data-image-src]' ).attr( 'data-image-src' );
		}

		return encodeURIComponent( image );

	},

	getTitle: function( elm ) {

		var $elm = $( elm );
		var title = $elm.closest( '*[data-title]' ).data( 'title' );

		// //console.log('/// getTitle:', title );

		if ( title )
			return encodeURIComponent( socialLinks.siteTitle + socialLinks.TEXT_DIVIDER + title );

		return encodeURIComponent( socialLinks.siteTitle );

	},

	getUrl: function( elm ) {

		var $elm = $( elm );
		var url = $elm.closest( '*[data-share-url]' ).attr( 'data-share-url' );

		// //console.log('/// getUrl:', url );

		return encodeURIComponent( url );
	},

	openWindow: function( url, name, width, height ) {
		////console.log( 'socialLinks: openWindow', url, name, width, height );

		width = width || 500;
		height = height || 500;

		window.open( url, name, 'width=' + width + ',height=' + height );

	},


	// ----- EVENT LISTENERS ----- //
	onClick: function( e ) {
		////console.log( 'socialLinks: onClick' );

		if ( $.browser.desktop ) {

			e.preventDefault();

			var url = e.currentTarget.getAttribute( 'href' );
			var name = e.currentTarget.getAttribute( 'aria-label' );

			socialLinks.openWindow( url, name );

		}

	}
};